var exports = {
  "k": "additionalSettingsSection__yec1v_",
  "P": "propertyFormControl__t4UI02",
};

module.exports = exports;
